export default "__VITE_ASSET__a7338631__"